import { render, staticRenderFns } from "./CustomQuestions.vue?vue&type=template&id=31efd63e&"
import script from "./CustomQuestions.vue?vue&type=script&lang=js&"
export * from "./CustomQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomQuestions.vue"
export default component.exports